module.exports = __webpack_public_path__ + "img/login_img.87a4db71.svg";